import React from 'react';
import css from './Header.module.css';
import { H3, Paragraph } from '../../text';
import { Image } from '../../images';
import clsx from 'clsx';
import { ChevronImage } from '../../../assets/images';

export interface HeaderProps {
  title: string;
  expanded: boolean;
  collapsable?: boolean;
  onClick: () => void;
}

const imageWidth = 14;
const imageHeight = 8;

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const onClick = () => {
    props.collapsable !== false && props.onClick();
  };

  return (
    <div className={clsx(props.collapsable !== false ? css.selectionBorder : null)}>
      <button
        className={css.button}
        onClick={onClick}
        type="button"
        title={props.title}
      >
        {props.expanded || props.collapsable === false ? (
          <H3 className={css.headerText} text={props.title} />
        ) : (
          <Paragraph text={props.title} />
        )}
        {props.collapsable !== false ? (
          <Image
            source={ChevronImage}
            alternateText={props.title}
            width={imageWidth}
            height={imageHeight}
            className={clsx(
              css.image,
              props.expanded ? css.expandedImage : null
            )}
          />
        ) : null}
      </button>
    </div>
  );
};

export default Header;
